import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    auth: {
      status: false,
      token: {
        access: '',
        refresh: '',
      },
    },
    email: {
      address: '',
      validated: false,
    },
    profile: {
      id: 0,
      username: '',
      join: 0,
    },
    member: {
      pro: false,
      exp: 0,
      max: 0,
    },
    authorization: localStorage.getItem('authorization') || 'normal',
    role: {
      isServerOwner: false,
      ownedServers: [] as Array<{ server_id: number; server_name: string; uuid: string; is_active: boolean }>,
      authorizedServers: [] as Array<{ server_id: number; server_name: string; uuid: string; is_active: boolean }>,
    },
  }),
  getters: {
    isAuthenticated(state) {
      return state.auth.status;
    },
    getAccessToken(state) {
      return state.auth.token.access;
    },
    getRefreshToken(state) {
      return state.auth.token.refresh;
    },
    getEmail(state) {
      return state.email.address;
    },
    isEmailValidated(state) {
      return state.email.validated;
    },
    getUserId(state) {
      // 确保返回有效的用户ID
      const id = state.profile.id;
      if (id && id !== 0) {
        return id;
      }

      // 如果 store 中的 id 无效，尝试从 localStorage 获取
      const localId = localStorage.getItem('id');
      if (localId && localId !== 'null' && localId !== 'undefined') {
        const numericId = parseInt(localId);
        if (!isNaN(numericId) && numericId > 0) {
          return numericId;
        }
      }

      return id; // 返回原始值，即使可能是0
    },
    getUsername(state) {
      return state.profile.username;
    },
    getJoinDate(state) {
      return state.profile.join;
    },
    isProMember(state) {
      return state.member.pro;
    },
    getMembershipExpiry(state) {
      return state.member.exp;
    },
    getMaxMembership(state) {
      return state.member.max;
    },
    getIsServerOwner(state) {
      return state.role.isServerOwner;
    },
    getOwnedServers(state) {
      return state.role.ownedServers;
    },
    getAuthorizedServers(state) {
      return state.role.authorizedServers;
    },
    isAdmin(state) {
      return state.authorization === 'admin';
    },
  },
  actions: {
    updateEmail(newEmail: string) {
      this.email.address = newEmail;
    },
    updateUsername(newUsername: string) {
      this.profile.username = newUsername;
    },
    updateAuthStatus(status: boolean) {
      this.auth.status = status;
    },
    updateAccessToken(token: string) {
      this.auth.token.access = token;
    },
    updateRefreshToken(token: string) {
      this.auth.token.refresh = token;
    },
    updateEmailStatus(status: boolean) {
      this.email.validated = status;
    },
    updateUserId(id: number) {
      this.profile.id = id;
    },
    updateJoinDate(date: number) {
      this.profile.join = date;
    },
    updateProMembershipStatus(status: boolean) {
      this.member.pro = status;
    },
    updateMembershipExpiry(date: number) {
      this.member.exp = date;
    },
    updateMaxMembership(limit: number) {
      this.member.max = limit;
    },
    updateRoleInfo(roleInfo: { is_server_owner: boolean; owned_servers: any[]; authorized_servers: any[] }) {
      this.role.isServerOwner = roleInfo.is_server_owner;
      this.role.ownedServers = roleInfo.owned_servers;
      this.role.authorizedServers = roleInfo.authorized_servers;
    },
    updateAuthorization(auth: string) {
      this.authorization = auth;
      localStorage.setItem('authorization', auth);
    },
    clearRoleInfo() {
      this.role.isServerOwner = false;
      this.role.ownedServers = [];
      this.role.authorizedServers = [];
    },
  },
});
